export default __webpack_public_path__ + "static/media/gains.924f7298.webp";